import graphql__8bd07857d8de6c9e538d from "./__generated__/UpVoteButton_votable.graphql.js";import { graphql, useFragment } from "react-relay";
import classNames from "classnames";
import { defineMessages } from "react-intl";

import { useVoteButtonsLabel } from "./useVoteButtonsLabel";
import VoteButton from "./VoteButton";

const VOTE_TYPE_UP = "UP";

const UpVoteButton = props => {
  const votable = useFragment(UpVoteButton_votable, props.votable);
  const { votes, votesMode, currentViewerVote, authorizations } = votable;

  const isActive = currentViewerVote === VOTE_TYPE_UP;

  const { label, votesCountScreenReaderLabel } = useVoteButtonsLabel({
    votable,
    intlMessages,
    voteType: VOTE_TYPE_UP
  });

  const buttonClassName = classNames("text-success", props.buttonClassName, {
    "up-vote-button--active": isActive,
    "bg-white": !isActive
  });

  const iconClassName = classNames({
    "icon-like": votesMode === "LIKES",
    "fa fa-caret-up margin-right-none": votesMode === "VOTES"
  });

  return (
    <VoteButton
      {...props}
      votable={votable}
      tooltipContent={label}
      screenReaderLabel={label}
      voteType={VOTE_TYPE_UP}
      className="up-vote-button-container"
      iconClassName={iconClassName}
      buttonClassName={buttonClassName}
      votesCount={votes.up}
      votesCountScreenReaderLabel={votesCountScreenReaderLabel}
      authorization={authorizations.submitVote}
      triggerOnSignIn={true}
    />
  );
};

const UpVoteButton_votable = graphql__8bd07857d8de6c9e538d;

export default UpVoteButton;

const intlMessages = defineMessages({
  label: {
    id: "upVoteButton.vote.label",
    defaultMessage: "Je vote pour {remainingVotesMessage}"
  },
  likeLabel: {
    id: "upVoteButton.like.label",
    defaultMessage: "J'aime {remainingVotesMessage}"
  },
  labelActive: {
    id: "upVoteButton.vote.labelActive",
    defaultMessage: "Retirer mon vote"
  },
  likeLabelActive: {
    id: "upVoteButton.like.labelActive",
    defaultMessage: "Retirer mon like"
  },
  labelAdd: {
    id: "upVoteButton.vote.labelAdd",
    defaultMessage: "Ajouter un vote pour {remainingVotesMessage}"
  },
  likeLabelAdd: {
    id: "upVoteButton.like.labelAdd",
    defaultMessage: "Ajouter un like {remainingVotesMessage}"
  },
  labelVotesCountScreenReaderLabel: {
    id: "upVoteButton.vote.votesCountScreenReaderLabel",
    defaultMessage: "(votes pour)"
  },
  likeLabelVotesCountScreenReaderLabel: {
    id: "upVoteButton.like.votesCountScreenReaderLabel",
    defaultMessage: "(likes)"
  }
});
